import Image from 'next/legacy/image';
import { ReactNode } from 'react';
import FarmerSupportImage from '@/images/farmer-support.webp';
interface Props {
  text: string;
  children: ReactNode;
}
const FarmerSupport = ({
  text,
  children
}: Props) => {
  return <section className="pb-4 pt-3 pr-[122px] relative" data-sentry-component="FarmerSupport" data-sentry-source-file="FarmerSupport.tsx">
      <h6 className="text-neutral-90">{text}</h6>
      {children}
      <aside className="absolute right-0 bottom-0 h-28 w-[121px]">
        <Image src={FarmerSupportImage} placeholder="blur" layout="fill" objectFit="contain" alt="Farmer support" aria-hidden="true" role="presentation" data-sentry-element="Image" data-sentry-source-file="FarmerSupport.tsx" />
      </aside>
    </section>;
};
export default FarmerSupport;